import React from "react";
import {Box, Chip, Link, Paper, Stack, Typography} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import {formatDataIsoBR} from "../../../shared/utils/formatters";
import {getStatusColor, getStatusLabel} from "../../Licencas/licencasUtils";
import {getMeioLabel, plural} from "../planoVersaoUtils";

/*
 * As assinaturas que estão nesta versão (app-licencas, filtradas pelo plano e agrupadas pela versão). É quem fica
 * na versão quando outra é publicada. As canceladas aparecem, mas não contam para a versão ficar em uso.
 */
export default function AssinaturasDaVersao({licencas}) {
    if (licencas === null) {
        return (
            <Paper variant="outlined" sx={{p: {xs: 2, md: 2.5}}} component="section" aria-label="Assinaturas desta versão">
                <Typography variant="h6" component="h2" fontWeight={700}>Assinaturas desta versão</Typography>
                <Typography variant="body2" color="text.secondary" sx={{mt: 1}}>Não foi possível carregar as assinaturas agora.</Typography>
            </Paper>
        );
    }
    const vigentes = licencas.filter((licenca) => licenca.status !== 'CANCELADA').length;

    return (
        <Paper variant="outlined" sx={{p: {xs: 2, md: 2.5}}} component="section" aria-label="Assinaturas desta versão">
            <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{mb: 1}} flexWrap="wrap" useFlexGap gap={1}>
                <Typography variant="h6" component="h2" fontWeight={700}>Assinaturas desta versão</Typography>
                <Typography variant="caption" color="text.secondary">{plural(vigentes, 'vigente', 'vigentes')}</Typography>
            </Stack>
            {!licencas.length ? (
                <Typography variant="body2" color="text.secondary">Nenhuma assinatura nesta versão.</Typography>
            ) : (
                <Stack divider={<Box sx={{borderTop: 1, borderColor: 'divider'}} />}>
                    {licencas.map((licenca) => (
                        <Stack key={licenca.id} direction={{xs: 'column', sm: 'row'}} spacing={1} justifyContent="space-between" sx={{py: 1}}>
                            <Box sx={{minWidth: 0}}>
                                <Link component={RouterLink} to={`/licencas/${licenca.id}`} variant="body2" fontWeight={600} underline="hover" display="block">
                                    {licenca.empresa?.nome_fantasia || licenca.empresa?.razao_social || 'Empresa'}
                                </Link>
                                <Typography variant="caption" color="text.secondary" sx={{fontFamily: 'monospace'}}>{licenca.tenant_id}</Typography>
                            </Box>
                            <Stack direction="row" spacing={0.75} alignItems="center" useFlexGap flexWrap="wrap">
                                <Chip size="small" variant="outlined" label={getStatusLabel(licenca.status)} color={getStatusColor(licenca.status)} />
                                <Chip size="small" variant="outlined" label={getMeioLabel(licenca.meio_pagamento)} />
                                <Typography variant="caption" color="text.secondary">desde {formatDataIsoBR(licenca.validade_inicio)}</Typography>
                            </Stack>
                        </Stack>
                    ))}
                </Stack>
            )}
        </Paper>
    );
}
